import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

// Pages
import HomePage from "@/pages/HomePage";
import ChiSonoPage from "@/pages/ChiSonoPage";
import ServiziPage from "@/pages/ServiziPage";
import ConsulenzaPage from "@/pages/ConsulenzaPage";
import ContattiPage from "@/pages/ContattiPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import UtilityPage from "@/pages/UtilityPage";
import NovitaPage from "@/pages/NovitaPage";
import AdminPage from "@/pages/AdminPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
    <ThemeProvider>
    <AuthProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/chi-sono" element={<ChiSonoPage />} />
              <Route path="/servizi" element={<ServiziPage />} />
              <Route path="/consulenza" element={<ConsulenzaPage />} />
              <Route path="/contatti" element={<ContattiPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/registrati" element={<RegisterPage />} />
              <Route path="/area-clienti/*" element={<DashboardPage />} />
              <Route path="/utility" element={<UtilityPage />} />
              <Route path="/novita" element={<NovitaPage />} />
              <Route path="/novita/:id" element={<NovitaPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="/admin/*" element={<AdminPage />} />
              <Route path="/pagamento-successo" element={<PaymentSuccessPage />} />
              <Route path="/pagamento-annullato" element={<PaymentCancelPage />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
